import { render, staticRenderFns } from "./StatusVizTab.vue?vue&type=template&id=5ed00af4"
import script from "./StatusVizTab.vue?vue&type=script&lang=js"
export * from "./StatusVizTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports